import React, { useState, useEffect } from 'react';
import {
  Card,
  CardHeader,
  CardBody,
  Typography,
  Button,
} from "@material-tailwind/react";
import SideBar from './SideBar';

interface CardListProps {
  data: DataContent[];
  layout?: 'flex' | 'grid'; // Add layout prop
}
interface DataContent {
  _id: number;
  name: string;
  url: string;
  Biography: BioType[];
  image: {
    asset: {
      _ref: string;
    };
  };
}
interface BioType {
  children: Array<{ text: string }>;
}

const CardList = ({ data, layout = 'flex' }: CardListProps) => {
  const [selectedPerson, setSelectedPerson] = useState<DataContent | null>(null);

  // ✅ Prevent background scroll when sidebar is open
  useEffect(() => {
    if (selectedPerson) {
      const scrollY = window.scrollY;
      document.body.style.position = "fixed";
      document.body.style.top = `-${scrollY}px`;
      document.body.style.width = "100%";
      document.body.style.overflowY = "hidden";
    } else {
      const scrollY = document.body.style.top;
      document.body.style.position = "";
      document.body.style.top = "";
      document.body.style.width = "";
      document.body.style.overflowY = "";
      if (scrollY) {
        window.scrollTo(0, parseInt(scrollY || "0") * -1);
      }
    }
  }, [selectedPerson]);

  // Common card content
  const renderCard = (item: DataContent) => {
    const imgUrl = item.image?.asset
      ? `https://cdn.sanity.io/images/79vgbaej/production/${item.image.asset._ref.slice(6, -4)}.${item.image.asset._ref.slice(-3)}`
      : "";

    return (
      <Card
        key={item._id}
        className={`relative bg-white shadow-md rounded-xl flex flex-col items-center
          ${layout === 'grid' ? 'w-50 h-200' : 'w-36 sm:w-56 h-72 sm:h-80'}
        `}
      >
        <CardHeader floated={false} className="w-32 h-32 sm:w-36 sm:h-36 mx-auto mt-6"> 
          {imgUrl && <img className="object-cover h-full w-full rounded-lg" src={imgUrl} alt={item.name} />}
        </CardHeader>

        <CardBody className="text-center flex flex-col flex-1 w-full"> 
          <Typography color="blue-gray" className="mb-2 text-md font-semibold">
            {item.name}
          </Typography>

          <Typography color="blue-gray" className="mb-2 text-xs font-semibold text-gray-600 flex-1">
            {item.url}
          </Typography>

          <Button
            variant="outlined"
            size="sm"
            color="red"
            className="mt-auto rounded-full mx-auto" 
            onClick={() => setSelectedPerson(item)}
          >
            Biography
          </Button>
        </CardBody>
      </Card>
    );
  };

  if (layout === 'grid') {
    return (
      <>
        {data.length > 0 && data.map(renderCard)}
        <SideBar
          isOpen={!!selectedPerson}
          onClose={() => setSelectedPerson(null)}
          name={selectedPerson?.name || ""}
          url={selectedPerson?.url || ""}
          image={
            selectedPerson?.image?.asset
              ? `https://cdn.sanity.io/images/79vgbaej/production/${selectedPerson.image.asset._ref.slice(6, -4)}.${selectedPerson.image.asset._ref.slice(-3)}`
              : ""
          }
          biography={selectedPerson?.Biography}
        />
      </>
    );
  }

  // Default flex layout
  return (
    <div className="flex justify-start gap-3 sm:gap-5 p-2 sm:p-4 items-center flex-wrap">
      {data.length > 0 && data.map(renderCard)}
      <SideBar
        isOpen={!!selectedPerson}
        onClose={() => setSelectedPerson(null)}
        name={selectedPerson?.name || ""}
        url={selectedPerson?.url || ""}
        image={
          selectedPerson?.image?.asset
            ? `https://cdn.sanity.io/images/79vgbaej/production/${selectedPerson.image.asset._ref.slice(6, -4)}.${selectedPerson.image.asset._ref.slice(-3)}`
            : ""
        }
        biography={selectedPerson?.Biography}
      />
    </div>
  );
};

export default CardList;
